module.exports = __webpack_public_path__ + "img/ado-txt.b37bf850.svg";